<template>
  <div class="flex">
    <div class="flexLeft">
      <div style="height: 100%">
        <img style="height: 96%;" src="../../assets/img/usp/loginLeft.png" />
      </div>
      <div style="position: absolute;bottom: 20px;width: 100%;text-align: center;">
        <div class="bottomFise">
          版权所有：联合汽车电子有限公司
        </div>
        <div class="bottomFise">
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">沪ICP备15019161号-2</a>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502002340" target="_blank" style="padding-left:20px">沪公网安备 31011502002340 号</a>
        </div>
      </div>
    </div>
    <div class="flexRight">
    </div>
    <div class="loginDiv">
      <div style="padding: 80px;">
         <el-form
          ref="form"
          class="content"
          :model="form"
          label-width="80px"
          label-position="left"
        >
          <div style="text-align: center;paddingTop: 20px; paddingBottom: 55px">
            <img align="middle" style="width: 174px; height: 50px" src="../../assets/img/usp/logo.png" />
          </div>
          <usp-tabs v-model="activeIndex" v-loading="uiamLoginLoading" :before-leave="handleBeforeLeave" @tab-click="handleSelect">
            <usp-tab-pane label="个人用户" name="first" bottomLineWidth="22">
              <div>
                <div class="phoneDiv">
                  <el-input oninput="value=value.replace(/[^\d]/g,'')" maxlength=11 v-model.number="form.phone" placeholder="请输入手机号码"></el-input>
                </div>
                <div class="codeDiv" >
                  <el-input v-show="cipherOrCodeType === 'code'" maxlength="6" oninput="value=value.replace(/[^\d]/g,'')" v-model="form.check" placeholder="请输入验证码" autocomplete="off" class="input-with-select" >
                    <el-button slot="append" style="height: 56px;border: none;padding: 0;width: 158px;">
                      <CountDown v-show="showCount" :urlType="6" :isPhone="true" :phone="form.phone" :form="form" :countdownStyle="countdownStyle" @handleClick="clickBtn" />
                    </el-button>
                  </el-input>
                  <el-input v-show="cipherOrCodeType === 'cipher'" v-model="form.phonePassword" placeholder="请输入密码" autocomplete="new-password" show-password class="input-with-select">
                  </el-input>
                </div>
                <div>
                  <el-checkbox v-model="checkAgreement" size="medium">
                    我已完全阅读并同意
                    <el-button type="text" @click="goDevProtocol">联电开发者服务协议</el-button>
                    及
                    <el-button type="text" @click="goPrivacyProtocol" style="margin-left: 0">隐私政策</el-button>
                  </el-checkbox>
                </div>
                <div v-if="cipherOrCodeType === 'code'" class="codeDiv" style="text-align: right;padding-top: 0px;">
                  <el-button style="font-size: 16px;font-weight: 400;color: #4d78ff;" type="text" @click="cipherOrCode('cipher')">使用密码登录</el-button>
                </div>
                <div v-else-if="cipherOrCodeType === 'cipher'" class="codeDiv" style="text-align: right;padding-top: 0px;">
                  <el-button style="font-size: 16px;font-weight: 400;color: #4d78ff;" type="text" @click="cipherOrCode('code')">使用验证码登录</el-button>
                </div>
                <div v-if="cipherOrCodeType === 'code'" class="loginButtonDiv">
                  <el-button type="primary" class="signinButton" :disabled="(!canSubmit || !checkAgreement)" @click="signin()">登录/注册</el-button>
                </div>
                 <div v-if="cipherOrCodeType === 'cipher'" class="loginButtonDiv">
                  <el-button type="primary" style="height: 56px;border: none;padding: 0;width: 100%;" :disabled="!checkAgreement">
                    <CountDown v-show="showCount" :disabled="!checkAgreement" :urlType="9" countDownType="login" :isPhone="true" :phone="form.phone" :form="form" :countdownStyle="countdownStyle" @handleClick="clickBtn"  @logInClickBtn="logInClickBtn"/>
                  </el-button>
                </div>
              </div>
            </usp-tab-pane>
            <usp-tab-pane label="企业及高校用户" name="second" bottomLineWidth="22">
              <div>
                <div class="phoneDiv">
                  <el-input v-model.trim="form.email" placeholder="请输入企业邮箱"></el-input>
                </div>
                <div class="codeDiv" >
                  <el-input v-model.trim="form.emailPassword" placeholder="请输入密码" autocomplete="new-password"  show-password class="input-with-select">
                  </el-input>
                </div>
                <div>
                  <el-checkbox v-model="checkAgreementBus" size="medium">
                    我已完全阅读并同意
                    <el-button type="text" @click="goDevProtocol">联电开发者服务协议</el-button>
                    及
                    <el-button type="text" @click="goPrivacyProtocol" style="margin-left: 0">隐私政策</el-button>
                  </el-checkbox>
                </div>
                <div class="codeDiv" style="text-align: right;">
                  <el-button style="font-size: 16px;font-weight: 400;color: #838383;" type="text" @click="forgotPassword()">忘记密码</el-button>
                </div>
                <div class="loginButtonDiv">
                  <el-button type="primary" style="height: 56px;border: none;padding: 0;width: 100%;">
                    <CountDown v-show="showCount" :urlType="10" :disabled="(!checkAgreementBus)" countDownType="login" :isPhone="false" :email="form.email" :form="form" :countdownStyle="emailCountdownStyle" @handleClick="clickBtn"  @logInClickBtn="logInClickBtn"/>
                  </el-button>
                </div>
                <div style="paddingTop: 20px">
                  <el-button type="primary" class="registerButton" @click="register()">还没有账号？立即注册</el-button>
                </div>
              </div>
            </usp-tab-pane>
            <usp-tab-pane label="联电用户" name="third" bottomLineWidth="22">
            </usp-tab-pane>
          </usp-tabs>
        </el-form>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogDevProtocolVisible"
      fullscreen="true"
      lock-scroll="true"
      height="100%"
    >
      <div style="height:auto;" v-loading="dialogLoading">
        <iframe id="devProtocol" src="https://uspdeveloper.uaes.com/devProtocol.html" frameborder="0" width="100%" style="height: 90vh"></iframe>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogPrivacyProtocolVisible"
      fullscreen="true"
      lock-scroll="true"
      height="100%"
    >
      <div style="height:auto;" v-loading="dialogLoading">
        <iframe id="privacyProtocol" src="https://uspdeveloper.uaes.com/privacyProtocol.html" frameborder="0" width="100%" style="height: 90vh"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { remoteLoad } from '@/scripts/captcha'
import { mapGetters } from 'vuex'
import { getUserInfo, loginRegBySMS, phoneOrEmailLoginReg, emailLoginReg, checkRegVipEmailSubmit, checkRegVipEmail, useCodeGetToken } from '@/api/modules/iam'
import CountDown from '@/components/CountDown.vue'
import store from '@/store/index'
import UspTabPane from '@/components/uaesTabs/tab-pane'
import UspTabs from '@/components/uaesTabs/tabs'
import { getPasswordRSAV } from '@/scripts/utils'
export default {
  name: 'Login',
  components: {
    CountDown,
    UspTabPane,
    UspTabs
  },
  data() {
    return {
      inited: false,
      form: {
        phone: '',
        check: '',
        phonePassword: '',
        email: '',
        emailPassword: ''
      },
      showCount: true,
      activeIndex: 'first',
      canSubmit: false,
      cipherOrCodeType: 'code',
      countdownStyle: {
        background: '#DDDDDD',
        color: '#FFFFFF',
        height: '56px',
        borderBottomLeftRadius: 'inherit',
        borderTopLeftRadius: 'inherit',
        width: '100%'
      },
      emailCountdownStyle: {
        background: '#4d78ff',
        color: '#DBDBDB',
        height: '56px',
        width: '100%'
      },
      checkAgreement: false,
      checkAgreementBus: false,
      dialogDevProtocolVisible: false,
      dialogPrivacyProtocolVisible: false,
      dialogLoading: true,
      uiamCode: '',
      uiamLoginFlag: false,
      uiamLoginLoading: false
    }
  },
  computed: {
    ...mapGetters({
      // userInfo: 'userAuth/getUsersCurrentInfo'
    }),
    showPage() {
      // const auth_type = global.APP_CONFIG.auth_type
      const flag = true || this.userInfo
      return flag
    }
  },
  watch: {
    async $route(_to, _from) {
      if (!this.inited) {
        await this.init()
      }
    }
  },
  async created() {
    this.uiamCode = this.$route.query['code']
    await this.init()

    if (this.uiamCode) {
      this.uiamLoginFlag = true
      this.uiamLoginLoading = true
      await this.signinWithCode()
    }
  },
  methods: {
    handleSelect(e) {
      this.activeIndex = e.name
      console.log(e.name)
      if (this.activeIndex === 'third') {
        this.insideLogin()
      }
    },
    handleBeforeLeave(newActiveName, oldActiveName) {
      return newActiveName !== 'third'
    },
    cipherOrCode(status) {
      var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!reg.test(this.form.phone)) {
        this.countdownStyle.background = '#DDDDDD'
        this.countdownStyle.color = '#FFF'
      }
      else {
        this.countdownStyle.background = '#4d78ff'
        this.countdownStyle.color = '#FFF'
      }
      this.form.phone = ''
      this.form.check = ''
      this.form.phonePassword = ''
      this.cipherOrCodeType = status
      console.log('---------------')
      console.log(this.form.phone)
    },
    clickBtn(status) {
      this.canSubmit = status
    },
    logInClickBtn() {
      this.signin()
    },
    isNull(str) {
      if (str === '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    },
    async init() {
      setTimeout(() => {
        remoteLoad('https://turing.captcha.qcloud.com/TCaptcha.js')
      }, 10)
      this.inited = true
    },
    insideLogin() {
      // 内部登录
      // 生产环境 https://uiam.uaes.com/idp/oauth2/authorize
      // 开发环境 https://uiam-qa.uaes.com/idp/oauth2/authorize
      const uiamOauth2Url = 'https://uiam.uaes.com/idp/oauth2/authorize'
      const clientId = 'USP'
      const param = `?state=third&response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(window.location.href)}`
      window.location.href = `${uiamOauth2Url}${param}`
    },
    async signinWithCode() {
      // 内部用户UIAM登录
      const res = await useCodeGetToken({ code: this.uiamCode })
      this.uiamLoginFlag = false
      this.uiamLoginLoading = false

      if (res.code === 0) {
        this.$message({
          message: '登录成功！即将跳转至首页！',
          type: 'success',
          duration: 1000
        })
        // 登陆成功 获取user信息 保存本地 并且跳转回首页
        setTimeout(() => {
          this.userInfo()
        }, 1000)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
        await this.$router.push('/login')
      }
    },
    async signin() {
      const that = this
      const cipherOrCodeType = this.cipherOrCodeType
      let res
      // 判断是否为个人用户登录
      if (this.activeIndex === 'first') {
        if (this.isNull(this.form.phone)) {
          this.$message({ message: '请输入手机号', type: 'warning' })
          return null
        }
        // 判断是否为个人用户验证码登录
        if (cipherOrCodeType === 'code') {
          if (this.isNull(this.form.check)) {
            this.$message({ message: '请输入验证码', type: 'warning' })
            return null
          }
          res = await loginRegBySMS({ 'phone': that.form.phone, 'code': that.form.check })
        }
        else {
          // 如果不是验证码登录则为密码登录
          console.log('手机号的密码')
          console.log(this.form.phonePassword)
          if (this.isNull(this.form.phonePassword)) {
            this.$message({ message: '请输入密码', type: 'warning' })
            return null
          }
          res = await phoneOrEmailLoginReg({
            nation: '86',
            'phone': that.form.phone,
            'password': getPasswordRSAV(that.form.phonePassword),
            'captcha': that.form.captcha
          })
        }
      }
      // 如果不是个人用户登录则为合作企业及高校用户登录
      else if (this.activeIndex === 'second') {
        if (this.isNull(this.form.email)) {
          this.$message({ message: '请输入企业邮箱', type: 'warning' })
          return null
        }
        if (this.isNull(this.form.emailPassword)) {
          this.$message({ message: '请输入密码', type: 'warning' })
          return null
        }
        const email = that.form.email
        // 判断是否有@uaes.com
        if (email.indexOf('@uaes.com') > 0) {
          res = await checkRegVipEmail({ 'email': email })
          if (res.code === 0) {
            const encryptPassword = getPasswordRSAV(that.form.emailPassword)
            res = await emailLoginReg({
              'email': email,
              'encryptPassword': encryptPassword,
              'password': that.form.emailPassword,
              'captcha': that.form.captcha
            })
            if (res.code === 0) {
              res = await checkRegVipEmailSubmit({
                'email': email,
                'password': encryptPassword,
                'captcha': that.form.captcha,
                'relationEnterprise': '1'
              })
            }
          }
        }
        else {
          res = await phoneOrEmailLoginReg({
            'email': email,
            'password': getPasswordRSAV(that.form.emailPassword),
            'captcha': that.form.captcha
          })
        }
      }

      if (res.code === 0) {
      // submitVisible.value = true
        this.form = {
          phone: '',
          check: '',
          phonePassword: '',
          email: '',
          emailPassword: ''
        }
        this.$message({
          message: '登录成功！即将跳转至首页！',
          type: 'success',
          duration: 1000
        })
        // 登陆成功 获取user信息 保存本地 并且跳转回首页
        setTimeout(() => {
          this.userInfo()
        }, 1000)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    register() {
      this.$router.push('/emailReg')
    },
    forgotPassword() {
      this.$router.push('/forgotPassword')
    },
    async userInfo() {
      const res = await getUserInfo()
      if (res.code === 0) {
        localStorage.setItem('usersCurrentInfo', JSON.stringify(res.data))
        store.commit('userAuth/usersCurrentInfo', res.data)
        // localStorage.setItem('userInfo', JSON.stringify(res.data))
        this.$router.push('/')
      }
    },
    goDevProtocol() {
      this.dialogLoading = true
      this.dialogDevProtocolVisible = true
      setTimeout(() => {
        this.dialogLoading = false
      }, 2000)
      setTimeout(function() {
        /**
         * iframe-宽高自适应显示
         */
        const oIframe = document.getElementById('devProtocol')
        const deviceWidth = document.documentElement.clientWidth
        const deviceHeight = document.documentElement.clientHeight
        // 数字是页面布局宽度差值
        oIframe.style.width = Number(deviceWidth)
        // 数字是页面布局高度差
        oIframe.style.height = Number(deviceHeight) - 120 + 'px'
      }, 1000)
    },
    goPrivacyProtocol() {
      this.dialogLoading = true
      this.dialogPrivacyProtocolVisible = true
      setTimeout(() => {
        this.dialogLoading = false
      }, 2000)
      setTimeout(function() {
        /**
         * iframe-宽高自适应显示
         */
        const oIframe = document.getElementById('privacyProtocol')
        const deviceWidth = document.documentElement.clientWidth
        const deviceHeight = document.documentElement.clientHeight
        // 数字是页面布局宽度差值
        oIframe.style.width = Number(deviceWidth)
        // 数字是页面布局高度差
        oIframe.style.height = Number(deviceHeight) - 120 + 'px'
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
  ::-webkit-scrollbar{

    display:none;

}
  .login-form{
    text-align: center;
  }
  .flex{
    display: flex
  }
  .flexLeft{
    // flex: 2;
    width: calc(100vw * 0.71);
    height: 100vh;
    position: relative;
  }
  .flexRight{
    background-color: #4d78ff;
    // flex: 0.8;
    // width: 100%;
    width: calc(100vw * 0.29);
    height: 100vh;
  }
  .loginDiv{
    //margin-top: 122px;
    position: absolute;
    // right: 230px;
    left: calc(100vw * 0.71 - 315px);
    background: #FFFFFF;
    box-shadow: 0px 17px 28px 4px rgba(0,127,243,0.09);
    border-radius: 4px;
    //min-height: 752px;
    min-height: 57vh;
    min-width: 630px;
    align-self: center;
    display: flow-root;
  }
  .phoneDiv{
    padding-top: 22px;
    text-align: center;
  }
  .codeDiv{
    padding-top: 22px;
    text-align: center;
  }
   .loginButtonDiv{
    padding-top: 47px;
    text-align: center;
  }
  .loginBottonTypeFace{
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .signinButton{
    background: #4d78ff;
    height:56px;
    width:100%
  }
  .registerButton{
    background: #FFFFFF;
    height:56px;
    width:100%;
    color:#4d78ff;
    border: 1px solid #4d78ff;
  }
  ::v-deep .el-input__inner {
    height:56px
  }
  ::v-deep .el-tabs__nav-wrap::after {
    background:none
  }
  .bottomFise{
    font-size: 16px;
    font-weight: 400;
    color: #666666;
    line-height: 26px;
  }
  .bottomFise a{
    color: #666666;
    text-decoration:none;
  }
  .bottomFise a:hover{
    color: #666666;
    text-decoration:underline;
  }
  ::v-deep .el-tabs__active-bar {
    width: 22px !important;
    height: 6px !important;
    border-radius: 3px;
    background: #4d78ff
  }
  ::v-deep .el-tabs__nav {
    transform: translateX(17%) !important;
    display: block;
    align-items: center;
    align-self: center;
    text-align: center;
  }
  ::v-deep .el-tabs__item {
    font-size: 18px;
    font-weight: bold;
    color: #838383;
  }
  ::v-deep .el-tabs__active-bar{
    // transform: translateX(40px) !important;
  }
  ::v-deep .el-tabs__item.is-active {
    font-size: 18px;
    font-weight: bold;
    color: #4d78ff;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 15px;
    right: 15px;
    font-size: 30px;
  }
</style>
